export default __webpack_public_path__ + "static/media/IMG_0298.70f68582.JPG";